/**
 * Created by piotr.pozniak@thebeaverhead.com on 15/12/2020.
 */
import React, { useContext } from "react";
import InfiniteScroll from "react-infinite-scroller";
import WidgetSettingsContext from "../../../contexts/WidgetSettingsContext";
import appConfig from "../../../appConfig";
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props
 * @param {Boolean} [props.loading]
 * @param {Boolean} [props.hasMore]
 * @param {Boolean} [props.embedded]
 * @param {function} [props.onLoadMore]
 * @param {String} [props.className]
 */
const InfiniteScrollWrapper = (props) => {
  const { embedded, hasMore, loading } = props;
  const widgetSettings = useContext(WidgetSettingsContext);
  const { t } = useTranslation();

  const hasInfiniteScroll =
    Number.parseInt(widgetSettings["infiniteScroll"]) === 1;

  const infiniteScrollParent = widgetSettings["infiniteScrollParentSelector"];

  const infiniteScrollUseWindow = embedded && infiniteScrollParent == "";

  /**
   * react-infinite-scroller re-arms its scroll listener as soon as `hasMore`
   * flips back to true (right when a fetch completes). If the user is still
   * sitting within the scroll threshold at that exact moment, the very next
   * native scroll event fires loadMore again before `loading` has had a
   * chance to block it - guard against that duplicate trigger here.
   * @param page
   */
  const onMore = (page) => {
    if (loading) {
      return;
    }

    props.onLoadMore(page);
  };

  /**
   *
   * @returns {Element}
   */
  const getScrollParent = () => {
    let parent = null;

    if (props.embedded) {
      if (infiniteScrollParent == "") {
        return window;
      }

      const nodesList = document.querySelectorAll(infiniteScrollParent);

      if (nodesList && nodesList.length) {
        if (nodesList.length > 1) {
          console.log(
            appConfig.displayName +
              ": There are more nodes matching infinite scroll parent selector, selecting first one of the following list:",
            nodesList
          );
        }
        return nodesList[0];
      }
    } else {
      // the admin builder's live preview panel (WidgetPreview.js) renders its
      // scrollable region with a stable `calendar-background` class - this is
      // the actual container the user scrolls, not the legacy "chat-wrap-inner"
      // (which is the settings sidebar's own wrapper, unrelated to the preview)
      parent = document.getElementsByClassName("calendar-background")[0];
    }

    return parent;
  };

  // only in real public embeds - the admin builder's own preview chrome doesn't
  // contain focus-triggered scrollIntoView within its preview panel, so a deep
  // focusable element there scrolls the whole builder page instead
  const loadMoreFallback =
    embedded && hasInfiniteScroll && hasMore && !loading ? (
      <button
        type="button"
        className="dce-btn-reset sr-only"
        onClick={() => props.onLoadMore()}
      >
        {t("Load more events")}
      </button>
    ) : null;

  return hasInfiniteScroll && props.children ? (
    <>
      <InfiniteScroll
        pageStart={1}
        className={props.className}
        loadMore={onMore}
        hasMore={hasMore && !loading}
        loader={null}
        initialLoad={false}
        getScrollParent={getScrollParent}
        useWindow={infiniteScrollUseWindow}
        aria-busy={loading}
      >
        {props.children}
      </InfiniteScroll>
      {loadMoreFallback}
    </>
  ) : (
    <div className={props.className} aria-busy={loading}>
      {props.children}
    </div>
  );
};

export default InfiniteScrollWrapper;
